/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Contact_DescriptionInputs */

const en_directory_resources_contact_description = /** @type {(inputs: Directory_Resources_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this channel for product questions, directory feedback, and business inquiries.`)
};

const zh_directory_resources_contact_description = /** @type {(inputs: Directory_Resources_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可通过此渠道咨询产品问题、提交目录反馈或洽谈商务合作。`)
};

/**
* | output |
* | --- |
* | "Use this channel for product questions, directory feedback, and business inquiries." |
*
* @param {Directory_Resources_Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_contact_description = /** @type {((inputs?: Directory_Resources_Contact_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Contact_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_contact_description(inputs)
	return zh_directory_resources_contact_description(inputs)
});
export { directory_resources_contact_description as "directory.resources.contact.description" }